import { render, staticRenderFns } from "./rewardOnePlusGiftEdit.vue?vue&type=template&id=4a07da6d&scoped=true&"
import script from "./rewardOnePlusGiftEdit.vue?vue&type=script&lang=js&"
export * from "./rewardOnePlusGiftEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a07da6d",
  null
  
)

export default component.exports